import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthGuard from './auth_guard';
import NotAuthGuard from './not_auth_guard';
import NotPaidGuard from './not_paid_guard';
import project from './project';
import finance from './finance';
import other from './other';
import target from "@/router/target";

Vue.use(VueRouter);

let routes = [
    {
        path: '',
        name: 'index',
        component: () => import('../views/Index'),
        beforeEnter: NotAuthGuard
    },
    {
        path: '/diary/day',
        name: 'diary',
        component: () => import('../views/Diary/Diary.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.diary', customName: null, disabled: true, to: {} },
            { name: 'msg.dayPlan', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/diary/week',
        name: 'week',
        component: () => import('../views/Diary/Week.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.diary', customName: null, disabled: true, to: {} },
            { name: 'msg.weekPlan', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/diary/month',
        name: 'month',
        component: () => import('../views/Diary/Month.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.diary', customName: null, disabled: true, to: {} },
            { name: 'msg.monthPlan', customName: null, disabled: true, to: {} },
        ]
    },

    {
        path: '/billing/packages',
        name: 'packages',
        component: () => import('../views/Billing/Packages.vue'),
        beforeEnter: NotPaidGuard,
        breadcrumbs: [
            { name: 'msg.profile', customName: null, disabled: false, to: {name: 'profile'} },
            { name: 'msg.billing', customName: null, disabled: true, to: {} },
            { name: 'msg.subscriptionPackages', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/billing/error',
        name: 'billing_error',
        component: () => import('../views/Billing/Error.vue'),
        beforeEnter: NotPaidGuard,
        breadcrumbs: [
            { name: 'msg.profile', customName: null, disabled: false, to: {name: 'profile'} },
            { name: 'msg.billing', customName: null, disabled: true, to: {} },
            { name: 'msg.paymentError', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/billing/processing',
        name: 'billing_processing',
        component: () => import('../views/Billing/Processing.vue'),
        beforeEnter: NotPaidGuard,
        breadcrumbs: [
            { name: 'msg.profile', customName: null, disabled: false, to: {name: 'profile'} },
            { name: 'msg.billing', customName: null, disabled: true, to: {} },
            { name: 'msg.processingPayment', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/billing/success',
        name: 'billing_success',
        component: () => import('../views/Billing/Success.vue'),
        beforeEnter: NotPaidGuard,
        breadcrumbs: [
            { name: 'msg.profile', customName: null, disabled: false, to: {name: 'profile'} },
            { name: 'msg.billing', customName: null, disabled: true, to: {} },
            { name: 'msg.successfulPayment', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Auth/Login'),
        beforeEnter: NotAuthGuard
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import('../views/Auth/Registration'),
        beforeEnter: NotAuthGuard
    },
    {
        path: '/recovery-password',
        name: 'recovery_password',
        component: () => import('../views/Auth/Recovery'),
        beforeEnter: NotAuthGuard
    },
    {
        path: '/new-password',
        name: 'new-password',
        component: () => import('../views/Auth/NewPassword'),
        beforeEnter: NotAuthGuard
    },
    {
        path: '/confirm-email',
        name: 'confirm_email',
        component: () => import('../views/Auth/ConfirmEmail'),
    },
    {
        path: '/',
        redirect: {name: 'diary'}
    },
    {
        path: '*',
        name: '404',
        component: () => import('../views/Page404'),
    }
];

routes = routes.concat(project);
routes = routes.concat(finance);
routes = routes.concat(other);
routes = routes.concat(target);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router
